export default process.env.REACT_APP_API_REPORT_URL;
